import { render, staticRenderFns } from "./s01-summary.vue?vue&type=template&id=67747344&scoped=true"
import script from "./s01-summary.vue?vue&type=script&lang=js"
export * from "./s01-summary.vue?vue&type=script&lang=js"
import style0 from "./s01-summary.vue?vue&type=style&index=0&id=67747344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67747344",
  null
  
)

export default component.exports